module.exports = __webpack_public_path__ + "static/images/bglight.e9de738.png";